import { notification, Space } from 'antd'
import { FC, useState } from 'react'
import { useAppDispatch } from '../../../../app/hook'

import { SVGs } from '../../../../assets'
import { BitazzaText } from '../../../../components'
import { getAvatarImage } from '../../../../util/getAvatar'
import { fetchMyProfile } from '../../myProfileSlice'
import Styles from './ProfileHeader.module.scss'
import { ProfileNameModal } from './ProfileNameModal/ProfileNameModal'

interface Props {
    userData: usersRequest
    isNameOnly?: boolean
    onChangeProfileName?: (name: string) => void
    editable: boolean
}
export const ProfileHeader: FC<Props> = ({
    userData,
    isNameOnly,
    onChangeProfileName,
    editable,
}) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const dispatch = useAppDispatch()

    const onCLoseModal = () => {
        setIsModalOpen(false)
    }

    const onOpenModal = () => {
        setIsModalOpen(true)
    }

    const onFinish = async (values: any) => {
        //TODO: handle
        const res: any =
            onChangeProfileName &&
            (await onChangeProfileName(values.profileName))

        if (res.payload.status !== 200) {
            notification.open({
                message:
                    typeof res.payload === 'string'
                        ? res.payload
                        : res?.payload?.data?.additionalInfo ||
                          'Something went wrong',
            })
        } else {
            notification.open({
                message: 'Your name has been updated',
            })
            dispatch(fetchMyProfile())
            setIsModalOpen(false)
        }
    }

    return (
        <>
            <ProfileNameModal
                isOpen={isModalOpen}
                onCLoseModal={onCLoseModal}
                profileName={userData?.additional_user_info?.profileName}
                onChangeProfileName={onFinish}
            />

            <div className={Styles.container}>
                <img
                    src={getAvatarImage(userData.tier?.name)}
                    width={88}
                    alt="avatar"
                />
                <Space
                    direction="vertical"
                    size={0}
                    className={Styles.titleContainer}
                >
                    <BitazzaText
                        content={userData.additional_user_info?.profileName}
                        format="t28"
                        color="#FFFFFF"
                    />
                    {!isNameOnly && (
                        <div className={Styles.trophy}>
                            <img
                                src={SVGs.trophyIcon}
                                alt="trophy"
                                width={14}
                            />
                            <BitazzaText
                                content={userData.rank?.toString() || 'N/A'}
                                format="t16"
                                color="#FFFFFF"
                                bold
                            />
                        </div>
                    )}
                </Space>

                {!isNameOnly && editable ? (
                    <img
                        className={Styles.editIcon}
                        src={SVGs.editIcon}
                        alt="edit-icon"
                        onClick={() => onOpenModal()}
                    />
                ) : null}
            </div>

            {/* <PageHeader
                title={
                    <Space
                        direction="vertical"
                        size={0}
                        className={Styles.titleContainer}
                    >
                        <BitazzaText
                            content={userData.additional_user_info?.profileName}
                            format="t28"
                            color="#FFFFFF"
                        />
                        {!isNameOnly && (
                            <div className={Styles.trophy}>
                                <img
                                    src={SVGs.trophyIcon}
                                    alt="trophy"
                                    width={14}
                                />
                                <BitazzaText
                                    content={userData.rank?.toString() || 'N/A'}
                                    format="t16"
                                    color="#FFFFFF"
                                    bold
                                />
                            </div>
                        )}
                    </Space>
                }
                className={Styles.container}
                tags={
                    !isNameOnly && editable ? (
                        <img
                            src={SVGs.editIcon}
                            alt="edit-icon"
                            onClick={() => onOpenModal()}
                        />
                    ) : undefined
                }
                avatar={{
                    src: getAvatarImage(userData.tier?.name),
                    size: 200,
                }}
            ></PageHeader> */}
        </>
    )
}
